export default __webpack_public_path__ + "static/media/raufuchat.8de88c9b.PNG";